<template>
  <component
    :is="computedAs"
    :class="computedClass"
    class="jade-list-item"
    @click="() => $emit('onClick')"
  >
    <div
      v-if="$slots.leading"
      class="jade-list-item__leading"
    >
      <slot name="leading"></slot>
    </div>

    <div class="jade-list-item__main">
      <jade-list-item-content v-bind="$props">
        <template #tooltip>
          <slot name="tooltip"></slot>
        </template>
      </jade-list-item-content>
    </div>

    <div class="jade-list-item__trailing">
      <div class="trailing-text-align jade-list-item__trailing-item">
        <slot
          v-if="$slots.trailing"
          name="trailing"
        />

        <jade-text
          v-else
          color="medium"
          variant="text-medium"
          weight="medium"
        >
          {{ trailing }}
        </jade-text>
      </div>

      <jade-icon
        v-if="navigation"
        use="chevron-right"
        color="low"
        size="medium"
        data-testid="navigation"
      />
    </div>
  </component>
</template>

<script>
import VARIANT_ENUM from '../enums/colors.enum'
import JadeIcon from '../JadeIcon/index.vue'
import JadeText from '../JadeText/index.vue'

import JadeListItemContent from './JadeListItemContent/index.vue'

export default {
  name: 'JadeListItem',
  components: {
    JadeIcon,
    JadeText,
    JadeListItemContent
  },
  props: {
    description: String,
    thirdLine: String,
    type: String,
    tooltip: String,
    value: String,
    trailing: [String, Number],
    label: {
      type: String,
      required: true
    },
    navigation: Boolean,
    compact: Boolean,
    as: {
      type: String,
      default: 'div'
    },
    variant: {
      type: String,
      validation: variant =>
        Object.values([
          VARIANT_ENUM.ACTIVE,
          VARIANT_ENUM.PRIMARY,
          VARIANT_ENUM.DANGER,
          VARIANT_ENUM.NEUTRAL
        ]).includes(variant),
      default: VARIANT_ENUM.NEUTRAL
    }
  },
  computed: {
    isInteractive () {
      return Boolean(this.$listeners.onClick)
    },
    computedClass () {
      const variant =
        this.variant === VARIANT_ENUM.PRIMARY
          ? VARIANT_ENUM.NEUTRAL
          : this.variant
      return {
        [`is-${variant}`]: variant,
        [`is-compact`]: this.compact,
        [`is-interactive`]: this.isInteractive
      }
    },
    computedAs () {
      if (this.as) return this.as
      return this.isInteractive ? 'button' : 'div'
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade/css/list-item.css';

.trailing-text-align .jade-text {
  text-align: end;
}
</style>
